import React from "react";

import IconWrap, { SvgIconProps } from "./IconWrap";

const ChevronDownIcon: React.FC<SvgIconProps> = (props) => {
  return (
    <IconWrap {...props}>
      <svg
        xmlns="http://www.w3.org/2000/svg"
        fill="none"
        viewBox="0 0 24 24"
        strokeWidth={2}
        stroke="currentColor"
        width="1em"
        height="1em"
        fontSize={"inherit"}
        focusable={false}
      >
        <path
          strokeLinecap="round"
          strokeLinejoin="round"
          d="m19.5 8.25-7.5 7.5-7.5-7.5"
        />
      </svg>
    </IconWrap>
  );
};

export default ChevronDownIcon;
